export default '/home/runner/work/explorer-website/explorer-website/node_modules/libsodium-sumo/dist/modules-sumo'